import { defaultDateFormat, generateText, type NodePutData } from '@lighthouse/shared'
import { isValid, lightFormat } from 'date-fns'
import { isEmpty } from 'rambda'

export const ConvertNodePutData2String = (data: NodePutData) => {
    switch (data.type) {
        case 'NULL': {
            return ''
        }
        case 'BOOL':
        case 'NUMBER':
        case 'TEXT': {
            return data.value === undefined ? '' : String(data.value)
        }
        case 'DATE': {
            if (!data.value) {
                return ''
            }
            if (typeof data.value === 'string') {
                return data.value
            }
            return isValid(data.value) ? lightFormat(data.value, defaultDateFormat) : ''
        }
        case 'RICH_TEXT': {
            if (isEmpty(data.value) || Array.isArray(data.value)) {
                return ''
            }
            return generateText(data.value)
        }
        case 'ARRAY': {
            if (!Array.isArray(data.value)) {
                return ''
            }
            return data.value.join(',')
        }
        default: {
            return ''
        }
    }
}
